/* esm.sh - esbuild bundle(@internetarchive/donation-banner-thermometer@0.4.3) esnext production */
import{__decorate as o}from"/v135/tslib@2.8.1/esnext/tslib.mjs";import{html as l,css as s,LitElement as b,nothing as m}from"/v135/lit@2.8.0/esnext/lit.mjs";import{property as i,customElement as f,query as d,state as c}from"/v135/lit@2.8.0/esnext/decorators.js";var r=class extends b{constructor(){super(...arguments),this.goalMessageMode="amount",this.goalNearMessage="We\u2019ve almost reached our goal!",this.goalReachedMessage="We've reached our goal!",this.goalAmount=75e5,this.currentAmountMode="on",this.currentAmount=0,this.thermometerValueWidth=0,this.thermometerFillWidth=0}render(){return l`
      <div
        class="container"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="${this.goalAmount}"
        aria-valuenow="${this.currentAmount}"
        aria-valuetext="${this.currentAmountDisplayValue}"
      >
        <div class="thermometer-message-container">
          <div class="thermometer-container">
            <div
              class="thermometer-background ${this.thermometerValuePosition}"
            >
              <div
                class="thermometer-fill"
                style="width: ${this.percentComplete}%"
              >
                ${this.thermometerValuePosition==="value-left"?this.thermometerValueTemplate:m}
              </div>
              ${this.thermometerValuePosition==="value-right"?this.thermometerValueTemplate:m}
            </div>
          </div>
          ${this.goalMessageMode!=="off"?l` <div class="donate-goal">${this.currentGoalMessage}</div> `:m}
        </div>
      </div>
    `}get thermometerValueTemplate(){return this.currentAmountMode==="off"?l`${m}`:l`
          <div class="thermometer-value">${this.currentAmountDisplayValue}</div>
        `}get thermometerValuePosition(){return this.thermometerValueWidth+10<this.thermometerFillWidth?"value-left":"value-right"}updated(e){if(e.has("resizeObserver")){let t=e.get("resizeObserver");this.disconnectResizeObserver(t),this.setupResizeObserver(this.resizeObserver)}e.has("currentAmountMode")&&(this.unobserveCurrentAmountResize(this.resizeObserver),this.observeCurrentAmountResize(this.resizeObserver))}disconnectedCallback(){this.disconnectResizeObserver(this.resizeObserver)}handleResize(e){var t;switch(e.target){case((t=this.shadowRoot)===null||t===void 0?void 0:t.host):this.style.setProperty("--bannerThermometerHeight",e.contentRect.height+"px");break;case this.thermometerValue:this.thermometerValueWidth=e.contentRect.width;break;case this.thermometerFill:this.thermometerFillWidth=e.contentRect.width;break}}setupResizeObserver(e){var t;!(!((t=this.shadowRoot)===null||t===void 0)&&t.host)||!e||(e.addObserver({handler:this,target:this.shadowRoot.host}),e.addObserver({handler:this,target:this.thermometerFill}),this.observeCurrentAmountResize(e))}disconnectResizeObserver(e){var t;!(!((t=this.shadowRoot)===null||t===void 0)&&t.host)||!e||(e.removeObserver({handler:this,target:this.shadowRoot.host}),e.removeObserver({handler:this,target:this.thermometerFill}),this.unobserveCurrentAmountResize(e))}observeCurrentAmountResize(e){!this.thermometerValue||!e||e?.addObserver({handler:this,target:this.thermometerValue})}unobserveCurrentAmountResize(e){!this.thermometerValue||!e||e?.removeObserver({handler:this,target:this.thermometerValue})}get goalMessage(){return this.currentAmount>=this.goalAmount?this.goalReachedMessage:this.goalNearMessage}get currentAmountDisplayValue(){return this.formatNumber(this.currentAmount)}get goalAmountDisplayValue(){return this.formatNumber(this.goalAmount)}formatNumber(e){if(e===0)return"$0";let t="MM",a=e/1e6,u=a<10,n=0;return u?n=Math.round((a+Number.EPSILON)*10)/10:n=Math.round(a),`$${n}${t}`}get currentGoalMessage(){switch(this.goalMessageMode){case"amount":return`${this.goalAmountDisplayValue} goal`;case"message":return this.goalMessage;case"off":return""}}get percentComplete(){return Math.min(this.currentAmount/this.goalAmount*100,100)}static get styles(){let e=s`var(--bannerThermometerHeight, 20px)`,t=s`var(--bannerThermometerCurrentValueLeftColor, #fff)`,h=s`var(--bannerThermometerProgressColor, #23765D)`,a=s`var(--bannerThermometerCurrentValueRightColor, ${h})`,u=s`var(--bannerThermometerBackgroundColor, #B8F5E2)`,n=s`var(--bannerThermometerBorder, 1px solid ${h})`,g=s`var(--bannerThermometerBorderRadius, calc(${e} / 2))`,v=s`var(--bannerThermometerGoalMessagePadding, 0 10px)`,p=s`var(--bannerThermometerGoalValueColor, #2c2c2c)`;return s`
      :host {
        display: block;
      }

      .container {
        height: 100%;
      }

      .thermometer-message-container {
        height: 100%;
        display: flex;
        align-items: center;
      }

      .thermometer-container {
        height: 100%;
        flex: 1;
      }

      .thermometer-background {
        background-color: ${u};
        padding: 0;
        height: 100%;
        border-radius: ${g};
        border: ${n};
        overflow: hidden;
        display: flex;
        align-items: center;
      }

      .thermometer-fill {
        background-color: ${h};
        text-align: right;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }

      .thermometer-value {
        font-weight: bold;
      }

      .value-left .thermometer-value {
        color: ${t};
        padding: 0 0.5rem 0 1rem;
      }

      .value-right .thermometer-value {
        color: ${a};
        padding: 0 1rem 0 0.5rem;
      }

      .donate-goal {
        text-align: left;
        padding: ${v};
        text-transform: uppercase;
        font-weight: bold;
        color: ${p};
      }
    `}};o([i({type:String})],r.prototype,"goalMessageMode",void 0);o([i({type:String})],r.prototype,"goalNearMessage",void 0);o([i({type:String})],r.prototype,"goalReachedMessage",void 0);o([i({type:Number})],r.prototype,"goalAmount",void 0);o([i({type:String})],r.prototype,"currentAmountMode",void 0);o([i({type:Number})],r.prototype,"currentAmount",void 0);o([i({type:Object})],r.prototype,"resizeObserver",void 0);o([d(".thermometer-value")],r.prototype,"thermometerValue",void 0);o([d(".thermometer-fill")],r.prototype,"thermometerFill",void 0);o([c()],r.prototype,"thermometerValueWidth",void 0);o([c()],r.prototype,"thermometerFillWidth",void 0);r=o([f("donation-banner-thermometer")],r);export{r as DonationBannerThermometer};
//# sourceMappingURL=donation-banner-thermometer.mjs.map